import React, { useState } from 'react';
import { HomeIcon, ClipboardDocumentListIcon, BookOpenIcon, QuestionMarkCircleIcon, Square3Stack3DIcon, UserGroupIcon, ChatBubbleLeftIcon, ChartBarIcon, AcademicCapIcon, Cog6ToothIcon } from '@heroicons/react/24/outline';
import { Link, useLocation } from 'react-router-dom';

// map of routes to labels and icons
const navItems = [
  { name: 'Dashboard', path: '/stats', icon: HomeIcon },
  { name: 'Exams', path: '/exams', icon: ClipboardDocumentListIcon },
  { name: 'Previous Year Exam', path: '/previous-exams', icon: BookOpenIcon },
  { name: 'Subjects', path: '/subjects', icon: AcademicCapIcon },
  { name: 'Questions', path: '/questions', icon: QuestionMarkCircleIcon },
  { name: 'Contexts', path: '/contexts', icon: Square3Stack3DIcon },
  { name: 'Users', path: '/users', icon: UserGroupIcon },
  { name: 'Threads', path: '/threads', icon: ChatBubbleLeftIcon },
  { name: 'Settings', path: '/settings', icon: Cog6ToothIcon },
];

export default function Sidebar({ collapsed, onToggle }) {
  const location = useLocation();

  return (
    <aside className={`bg-white border-r h-full flex flex-col transition-width duration-200 ${collapsed ? 'w-16' : 'w-64'}`}>
      <div className="flex items-center justify-between p-4">
        {!collapsed && <span className="text-xl font-bold">Admin</span>}
        <button onClick={onToggle} className="p-1 rounded hover:bg-gray-100">
          {collapsed ? '➡️' : '⬅️'}
        </button>
      </div>
      <nav className="flex-1 overflow-y-auto">
        {navItems.map(item => {
          const Icon = item.icon;
          const active = location.pathname.startsWith(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center p-3 mx-2 my-1 rounded-lg transition-colors duration-150 ${
                active ? 'bg-indigo-100 text-indigo-800' : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Icon className="h-6 w-6" />
              {!collapsed && <span className="ml-3 text-sm font-medium">{item.name}</span>}
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}
